import React, {Component} from 'react'
import { Card } from './../../../../../components'
import { SuggestTemplateStyle } from './../../../../../styles'
import { getAverageColor } from './../../../../../helpers/getAverageColor'

export default class SuggestTemplate extends Component {
  state = {
    color: false
  }

  componentDidMount() {
    
    getAverageColor(this.props.picture ? this.props.picture : null).then((data) => {
      this.setState({
        color: data
      })
    }).catch((e) => {
      console.log(e)
    })
  }

  render() {
    const { picture, picture_position, title, fields, isBrand, subtitle, category } = this.props
    const { color } = this.state
    return (
      <div className={`product-template--suggest ${SuggestTemplateStyle(picture ? picture : null, color)}`}>
        <div className="template-scroll">
          {
            picture && <div className={`template-left template-picture--${picture_position ? picture_position : 'center' }`}></div>
          }
          <div className={`template-right ${!picture ? 'full' : ''} template-content`}>
            <div className='flex'>
              { category && isBrand && (<span className="title-brand">{category}</span>) }
              { title && !isBrand  && (<h2 className='subtitle'>{ title }</h2> )}
              { isBrand && subtitle  && (<h2 className={`subtitle subtitle--brand `}>{ subtitle }</h2> )}
              { title && isBrand &&  (<h3 className="subtitle-h3"> {title} </h3>)}
              <div className="suggest-container">
                <div className="flex flex-wrap">
                  {
                    fields.items && fields.items.map((product, index) => (
                      <Card 
                        title={product.name} 
                        description={product.subTitle} 
                        slug={product.url} 
                        card_picture={product.picture} 
                        pdfs={product.pdfs} 
                        is_bookmark={product.is_bookmark}
                        slug_bookmark={product.slug_bookmark}
                        type="page"
                        label='discover'
                        key={index} />
                    ))
                  }
                  </div>
              </div>
            </div>
          
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Pages/container/Product/ProductTemplates/SuggestTemplate.js